import MomentUtils from '@date-io/moment';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import { Done, Error, Info, Warning } from '@material-ui/icons';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import { inject } from 'mobx-react';
import { SnackbarProvider } from 'notistack';
import * as React from 'react';
import config from './config';
import { Shell } from './core';
import { Notifier, NotifierInfoDialog } from './core/Notifier/';
import { IStores } from './Stores';
import theme from './Theme';

interface IAppProps {
    isLoggedIn?: boolean;
    checkLogin?: () => void;
}

@inject((stores: IStores) => ({
    checkLogin: stores.login.loginCheck,
    isLoggedIn: stores.global.isLoggedIn,
}))
class App extends React.Component<IAppProps> {
    public componentDidMount() {
        this.props.checkLogin!();
    }

    public render() {
        return (
            <CssBaseline>
                <SnackbarProvider
                    maxSnack={3}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    iconVariant={{
                        error: <Error />,
                        info: <Info />,
                        success: <Done />,
                        warning: <Warning />,
                    }}
                >
                    <>
                        <Notifier notificationConfig={config.NotificationConfig} />
                        <NotifierInfoDialog />
                        <MuiThemeProvider theme={theme}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                <Shell />
                            </MuiPickersUtilsProvider>
                        </MuiThemeProvider>
                    </>
                </SnackbarProvider>
            </CssBaseline>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx